import React from 'react';
import { AppKey } from '../../../../libs/apps';
import { CheckboxGroup } from '@lightbeamhealth/blueprint-form';
import { useApps } from '../../../../contexts/apps';
import { pairAppsWithKeys } from './utils';
import AppsSelect from './select';

interface AppsFilterProps {
  update: any;
  selectedAppKeys: AppKey[];
}

// TO DO: Future! Only show the apps that account is subscribed to
const AppsFilter: React.FC<AppsFilterProps> = ({ selectedAppKeys, update }) => {
  const { data } = useApps();
  const apps = data ? data.apps : null;
  const { selectedApps, options } = pairAppsWithKeys(selectedAppKeys, apps);

  return (
    <React.Fragment>
      <CheckboxGroup label="Programs" name="filters.apps" options={options} />
      <AppsSelect apps={apps} selectedApps={selectedApps} update={update} />
    </React.Fragment>
  );
};

export default AppsFilter;
